import { render, staticRenderFns } from "./AS_AboutContent.vue?vue&type=template&id=51470396&scoped=true&"
import script from "./AS_AboutContent.vue?vue&type=script&lang=js&"
export * from "./AS_AboutContent.vue?vue&type=script&lang=js&"
import style0 from "./AS_AboutContent.vue?vue&type=style&index=0&id=51470396&scoped=true&lang=css&"
import style1 from "./AS_AboutContent.vue?vue&type=style&index=1&id=51470396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51470396",
  null
  
)

export default component.exports